var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"excelDownloadButton"},[_c('download-excel',{attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"name":'tpo_' + _vm.formatDate(new Date()) + '.xls'}},[_vm._v("Download XLS")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }